import React from "react";
import { SwatchesPicker } from "react-color";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

const StyledSwatchesPicker = styled(SwatchesPicker)`
  box-shadow: none;
`;

export default function ColorPicker({ value, onChange }) {
  const handleChange = (color) => {
    onChange(color.hex);
  };

  return (
    <Stack
      sx={{
        mt: 2,
      }}
    >
      <Box sx={{ p: 2, mb: 2, backgroundColor: value, borderRadius: 4 }}></Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 1,
        }}
      >
        <StyledSwatchesPicker
          onChange={handleChange}
          color={value}
          width={"100%"}
        />
      </Box>
    </Stack>
  );
}
